
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexL41OkD7MiHPZAoCTfSPnhWR1EpFx1tX3Yvg_45HkLRPNQMeta } from "D:/web/vlan/dnet-cloud-backend/pages/index.vue?macro=true";
import { default as _91name_93qewcTLDvNsd_IE486JUJrJC7WrE4fyIPCaFt8MWKjUoMeta } from "D:/web/vlan/dnet-cloud-backend/pages/[name].vue?macro=true";
import { default as api_45docsutOFnGEL3jsUDV_45w0RhBl5iY6VXMviq8grVNCR_45qNogMeta } from "D:/web/vlan/dnet-cloud-backend/pages/api-docs.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("D:/web/vlan/dnet-cloud-backend/pages/index.vue")
  },
  {
    name: "name",
    path: "/:name()",
    component: () => import("D:/web/vlan/dnet-cloud-backend/pages/[name].vue")
  },
  {
    name: "api-docs",
    path: "/api-docs",
    component: () => import("D:/web/vlan/dnet-cloud-backend/pages/api-docs.vue")
  }
]